import React from 'react';

const AuditoriaContext = React.createContext({
  emAuditoria: false,
  loteSelecionado: {},
  guiasLoteSelecionado: [],
  guiasEmDuplicidade: [],
  guiaOriginal: {},
});

class AuditoriaProvider extends React.Component {
  state = {
    emAuditoria: false,
    loteSelecionado: {},
    guiasLoteSelecionado: [],
    guiasEmDuplicidade: [],
    guiaOriginal: {},
  }

  setEmAuditoria = (emAuditoria) => {
    this.setState({ emAuditoria: emAuditoria });
  }

  setLoteSelecionado = (loteSelecionado) => {
    this.setState({ loteSelecionado: loteSelecionado });
  }

  setGuiasLoteSelecionado = (guias) => {
    this.setState({ guiasLoteSelecionado: guias });
  }

  setGuiasEmDuplicidade = (guiasEmDuplicidade) => {
    this.setState({ guiasEmDuplicidade: guiasEmDuplicidade });
  }

  setGuiaOriginal = (guiaOriginal) => {
    this.setState({ guiaOriginal: guiaOriginal });
  }

  render () {
    return (
      <AuditoriaContext.Provider
        value={{
          emAuditoria: this.state.emAuditoria,
          setEmAuditoria: this.setEmAuditoria,
          loteSelecionado: this.state.loteSelecionado,
          setLoteSelecionado: this.setLoteSelecionado,
          guiasLoteSelecionado: this.state.guiasLoteSelecionado,
          setGuiasLoteSelecionado: this.setGuiasLoteSelecionado,
          guiasEmDuplicidade: this.state.guiasEmDuplicidade,
          setGuiasEmDuplicidade: this.setGuiasEmDuplicidade,
          guiaOriginal: this.state.guiaOriginal,
          setGuiaOriginal: this.setGuiaOriginal,
        }}
      >
        {this.props.children}
      </AuditoriaContext.Provider>
    );
  }
}

const AuditoriaConsumer = AuditoriaContext.Consumer;

function withAuditoria (Component) {
  return function ComponentWithAuditoriaContext (props) {
    return (
      <AuditoriaConsumer>
        {context => <Component {...context} {...props} />}
      </AuditoriaConsumer>
    );
  };
}

export { AuditoriaProvider, withAuditoria };
